import * as tslib_1 from "tslib";
import setSafeSendersOption from '../actions/setSafeSendersOption';
import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { EditSendersAndDomains } from 'owa-mail-option-common';
import { OptionDescription } from 'owa-options-controls';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var SafeSendersFull = /** @class */ (function (_super) {
    tslib_1.__extends(SafeSendersFull, _super);
    function SafeSendersFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeSendersFull.prototype.render = function () {
        var senders = getFallbackValueIfNull(this.props.optionState.safeSenders, this.props.junkEmailConfiguration.TrustedSendersAndDomains);
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_junkEmail_safeSenders),
            React.createElement(EditSendersAndDomains, { items: senders, onItemsChanged: function (safeSenders) { return setSafeSendersOption(safeSenders); }, mode: 2 /* EmailAddressAndDomain */ })));
    };
    SafeSendersFull = tslib_1.__decorate([
        reactive({
            optionState: function () { return store; },
            junkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
        })
    ], SafeSendersFull);
    return SafeSendersFull;
}(React.Component));
export default SafeSendersFull;
//# sourceMappingURL=SafeSendersFull.js.map